// globalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body,
  html {
    background: linear-gradient(#7945FF 0%, #00ADFF 100%);
    color: #fff;
    font-family: "Work Sans", sans-serif;
    font-weight: 400;
    margin: 0;
    min-height: 100vh;
    padding: 0;
  }

  body,
  button,
  html,
  input {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  p {
    font-size: 25px;
    font-weight: 400;

    @media only screen and (min-width: 768px) {
      font-size: 18px;
    }

    @media only screen and (min-width: 1400px) {
      font-size: 20px;
    }
  }

  *:focus {
    outline: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: "Secular One", sans-serif;
    font-size: 25px;
    letter-spacing: 0.1em;
    line-height: 2em;
    margin: 0;
    margin-bottom: 40px;
  }

  /**
  * until https://github.com/facebook/create-react-app/issues/11771
  * gets fixed, let's hide the problem and not address it
  */
  body
    > iframe[style*="2147483647"]:not([id="webpack-dev-server-client-overlay"]) {
    display: none;
  }

  h1 {
    font-size: 24px;

    @media only screen and (min-width: 768px) {
      font-size: 48px;
    }
  }

  h2 {
    font-size: 28px;

    @media only screen and (min-width: 768px) {
      font-size: 36px;
    }
  }

  span {
    display: inline;
  }

  strong {
    font-weight: 800;
  }

  button {
    align-items: center;
    background: #fff;
    border: 1px solid #fff;
    border-radius: 4px;
    color: #7945FF;
    cursor: pointer;
    display: flex;
    font-size: 20px;
    font-weight: 600;
    height: 43px;
    padding: 0 20px;

    @media only screen and (max-width: 768px) {
      font-size: 10px;
    }
  }

  button:hover {
    background: transparent;
    border: 1px solid #fff;
    color: #fff;
  }

  .chakra-ui-light {
    background: transparent;
  }

  .wallet-adapter-modal-title {
    color: #fff;
  }
`;

export default GlobalStyle;
